<template>
  <li class="language-selector" data-test="mobile-menu__language-selector">
    <ul>
      <MobileMenuItem :item="config.item" :item-modifier="itemModifier" :panel="true">
        <template #panel>
          <ul class="language-elements">
            <li v-for="(lang, index) in langs" :key="index" class="language">
              <a class="link" :href="lang.url">{{ lang.text }}</a>
            </li>
          </ul>
        </template>
      </MobileMenuItem>
    </ul>
  </li>
</template>

<script>
import MobileMenuItem from '../MobileMenuItem/MobileMenuItem'

const componentName = 'MobileLanguageSelector'

export default {
  name: componentName,
  components: {
    MobileMenuItem,
  },
  props: {
    config: Object,
  },
  data() {
    return {
      itemModifier: '',
      langs: [],
      select: null,
    }
  },
  created() {
    this.itemModifier = window.ibh.lang.current.text

    if (window.ibh?.lang?.list) {
      Object.keys(window.ibh.lang.list).forEach(lang => {
        const langInfo = window.ibh.lang.list[lang]
        this.langs.push({
          url: langInfo.url,
          text: langInfo.text,
          locale: lang,
        })
      })
    }
  },
}
</script>
